import axios from 'axios'
import { format } from 'date-fns'
import JobStatusService from '../../services/jobStatus.service';

var CancelToken = axios.CancelToken;
var Source = null;

export async function getJobDetails(store, { currentPage, pageSize, filters }) {
    try {
        const state = store.state ;
        let newFilters = filters || state.JobStatus.filters;
        pageSize = (!pageSize || pageSize <= 0) ? 1 : pageSize;
        store.setState({
            JobStatus:
            {  
                ...state.JobStatus,
                filters: newFilters,
                pagination: { ...state.JobStatus.pagination, pageSize },
                selectedTradeRules: [],
                isLoading: true
            }                
        });    

        if (Source) {
            Source.cancel();
        }
        Source = CancelToken.source();
        const { items, pagination } = await JobStatusService().getJobDetails(currentPage, pageSize, newFilters, Source.token);
        Source = null;
        store.setState({
            JobStatus: {
                ...store.state.JobStatus,
                items,
                pagination,
                filters: newFilters,
                isLoading: false
            },
            selectedTradeRules: [],
        });
    }
    catch (error) {
        if (axios.isCancel(error)) {
            console.log('request cancelled');
        }
        else {
            throw error;
        }
    }
}

